import { useSarahUI, type OpenSarahOptions } from '@/context/SarahUIContext'
import { SarahAvatar } from './SarahAvatar'

interface AskSarahButtonProps extends OpenSarahOptions {
  label?: string
  variant?: 'primary' | 'secondary' | 'card'
}

// Single reusable entry point so "Ask Sarah" looks and behaves the same
// everywhere it appears (Dashboard, Episode Details, Quiz Results) —
// intentional, limited placement rather than scattering chat buttons
// throughout the app (P3 UX requirement).
export function AskSarahButton({ label = 'Ask Sarah', variant = 'secondary', ...options }: AskSarahButtonProps) {
  const { openSarah } = useSarahUI()

  if (variant === 'card') {
    return (
      <button
        onClick={() => openSarah(options)}
        className="cyber-panel flex w-full items-center gap-3 p-4 text-left transition hover:border-teal-500/40"
      >
        <SarahAvatar size={36} />
        <div className="min-w-0 flex-1">
          <p className="font-display text-sm font-semibold text-white">{label}</p>
          <p className="text-xs text-white/50">Your CyberTales cybersecurity coach</p>
        </div>
        <span className="text-teal-300">→</span>
      </button>
    )
  }

  return (
    <button
      onClick={() => openSarah(options)}
      className={variant === 'primary' ? 'cyber-btn-primary' : 'cyber-btn-secondary'}
    >
      {label}
    </button>
  )
}
